import React from "react";

interface BreadcrumbItem {
  name: string;
  href?: string; // link is optional
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function ThermalBreadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="tw-flex tw-items-center tw-space-x-2" aria-label="Breadcrumb">
      {/* Home icon + "Projects" example */}
      <div className="tw-flex tw-items-center tw-space-x-1">
        {/* Home icon */}
        <svg
          className="tw-h-5 tw-w-5 tw-text-gray-500"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 9.75L12 3l9 6.75M4.5 10.5v9.75a.75.75 0 00.75.75h4.5m9-10.5v9.75a.75.75 0 01-.75.75h-4.5m0 0V14.25a1.5 1.5 0 00-3 0v6.75"
          />
        </svg>

        {/* If you want the first item to be clickable, you can link it; otherwise just show text */}
        {items[0]?.href ? (
          <a
            href={items[0].href}
            className="tw-text-gray-600 hover:tw-text-gray-800 tw-text-sm tw-font-medium"
          >
            {items[0].name}
          </a>
        ) : (
          <span className="tw-text-gray-600 tw-text-sm tw-font-medium">
            {items[0]?.name}
          </span>
        )}
      </div>

      {/* Render remaining items */}
      {items.slice(1).map((item, index) => (
        <div
          key={`${item.name}-${index}`}
          className="tw-flex tw-items-center tw-space-x-1"
        >
          {/* Chevron separator */}
          <svg
            className="tw-h-4 tw-w-4 tw-text-gray-400"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>

          {/* Link or text */}
          {item.href ? (
            <a
              href={item.href}
              className="tw-text-gray-600 hover:tw-text-gray-800 tw-text-sm tw-font-medium"
            >
              {item.name}
            </a>
          ) : (
            <span className="tw-text-gray-600 tw-text-sm tw-font-medium">
              {item.name}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
}
